import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const AccordionContent = styled.div`
  p {
    margin: 0;
  }
  p:not(:last-child) {
    margin-bottom: ${spacing.space16};
  }
`;
